import styled from "@emotion/styled";
import * as React from "react";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Loader, LoaderSize } from "components/loader";

interface IProps {
  isVisible: boolean;
  size?: LoaderSize;
  inline?: boolean;
}

interface IWrapperProps {
  isVisible: boolean;
}

const Wrapper = styled.div<IWrapperProps>`
  visibility: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? "visible" : "hidden")
  };
  opacity: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? 1 : 0)
  };
  transition: all 0.2s ease-in-out;
`;

export const LoaderAnimated: React.FC<IProps> = ({ size, inline, isVisible }) => (
  <Wrapper isVisible={isVisible}>
    <Loader size={size} inline={inline} />
  </Wrapper>
);
